import { EnvironmentOutlined, ShareAltOutlined } from '@ant-design/icons';
import { MyLogo, SharedSwitch, ShareGarageModal } from '@components';
import { isGranted } from '@lib';
import { ProfileLogoInput, TenantProfile } from '@services';
import { Button, Typography } from 'antd';
import React from 'react';
import { GarageVatRegistration } from '../GarageVatRegistration';
import './GarageDetailsHeader.css';

const { Title, Text } = Typography;

interface IProps {
  tenantProfile: TenantProfile;
  visible: boolean;
  setVisible: (value: boolean) => void;
  handleActiveChange: (id: number) => void;
  handleLogoDelete: () => Promise<void>;
  handleLogoUpdate: (profileLogo: ProfileLogoInput) => Promise<any>;
}

const GarageDetailsHeader: React.FC<IProps> = ({
  tenantProfile,
  visible,
  setVisible,
  handleActiveChange,
  handleLogoUpdate,
  handleLogoDelete,
}) => {
  return (
    <div className="wrapper-header">
      <div className="garage-logo-detailsWrapper logo-container">
        <MyLogo
          disabled={!isGranted('Pages.MyGarage.Manager')}
          url={tenantProfile.logo}
          handleLogoDelete={handleLogoDelete}
          handleLogoUpdate={handleLogoUpdate}
          data-testid="logo-component"
          enableCrop={false}
        />

        <div className="flex-column ml25">
          <Title className="tenant-name-title m0" level={1}>
            {tenantProfile.tenant?.name}
            {!isGranted('Pages.Tenants') && (
              <Button
                data-testid="share-button"
                tabIndex={2}
                className="share_button"
                onClick={() => setVisible(true)}
              >
                <ShareAltOutlined className="share_icon" />
              </Button>
            )}
          </Title>
          <EnvironmentOutlined style={{ color: '#5e657b' }} />
          {tenantProfile && (
            <Text className="address-details">{` ${tenantProfile.address}, ${tenantProfile.zipCode} ${tenantProfile.city}`}</Text>
          )}
          <Text className="address-details">{tenantProfile?.website?.toString()}</Text>
        </div>
      </div>
      {isGranted('Pages.Tenants') && (
        <SharedSwitch
          active={tenantProfile?.tenant?.isActive}
          onClick={() => handleActiveChange(tenantProfile.tenantId)}
        />
      )}
      {(isGranted('Pages.MyGarage.Manager') && tenantProfile?.vat && tenantProfile.vat > 0 && (
        <GarageVatRegistration vatNumber={tenantProfile.vatNumber} />
      )) || <></>}
      <ShareGarageModal
        visible={visible}
        setVisible={setVisible}
        companyLogo={tenantProfile.logo}
      />
    </div>
  );
};

export default GarageDetailsHeader;
